import React from 'react';
import { motion } from 'framer-motion';
export function ObjectionSection() {
  return <section className="py-24 px-6 bg-warm-900 text-warm-50" data-id="element-113">
      <div className="max-w-3xl mx-auto text-center" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 font-display" data-id="element-116">
            “PERO YO YA SÉ QUE MEAL PREP AYUDA…”
          </h2>

          <div className="space-y-8 text-lg md:text-xl leading-relaxed opacity-90" data-id="element-117">
            <p data-id="element-118">Sí. Y aun así no lo haces.</p>

            <p data-id="element-119">
              Porque lo que te vendieron como “meal prep” es un proyecto de
              domingo.
            </p>

            <div className="py-8" data-id="element-120">
              <p className="text-2xl font-bold text-teal-400 mb-2" data-id="element-121">Esto no.</p>
              <p data-id="element-122">
                Esto es una sesión de 90 minutos con orden exacto y checklist.
              </p>
            </div>

            <p className="font-medium border-t border-warm-800 pt-8 inline-block" data-id="element-123">
              Sin perfeccionismo. Sin cocina gourmet. Sin volverte otra persona.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}